import type { ReactNode } from 'react'

/**
 * Shown when there is genuinely nothing yet. Says what to do next rather than
 * just "no data" — the farm is a single person at the end of a long day.
 */
export function EmptyState({
  title,
  hint,
  action,
}: {
  title: string
  hint?: string
  action?: ReactNode
}) {
  return (
    <div className="empty-state">
      <p className="empty-title">{title}</p>
      {hint ? <p className="empty-hint">{hint}</p> : null}
      {action}
    </div>
  )
}
